import { render, staticRenderFns } from "./PresetsRaces.vue?vue&type=template&id=6e71f9d7&scoped=true"
import script from "./PresetsRaces.vue?vue&type=script&lang=js"
export * from "./PresetsRaces.vue?vue&type=script&lang=js"
import style0 from "./PresetsRaces.vue?vue&type=style&index=0&id=6e71f9d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71f9d7",
  null
  
)

export default component.exports